module.exports = __webpack_public_path__ + "static/media/famosi.8defcb26.jpg";